import { render, staticRenderFns } from "./StockInPreview.vue?vue&type=template&id=84cc7942&scoped=true"
import script from "./StockInPreview.vue?vue&type=script&lang=js"
export * from "./StockInPreview.vue?vue&type=script&lang=js"
import style0 from "./StockInPreview.vue?vue&type=style&index=0&id=84cc7942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cc7942",
  null
  
)

export default component.exports